import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js/auto';
import { infoModulator } from 'src/app/models/Modulator/infoModulator';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { WebsocketService } from 'src/app/services/websocket/websocket.service';

@Component({
    selector: 'app-device-settings-spl',
    templateUrl: './device-settings-spl.component.html',
    styleUrls: ['./device-settings-spl.component.scss'],
    standalone: false
})
export class DeviceSettingsSplComponent implements OnInit {
  infoModulator: infoModulator;
  infoSpl: any;
  charts: any = [];
  charts2: any = [];
  serial: string;
  device: any;
  userRole;
  progressValue: number = 65;
  canvas: any;
  ctx: any;
  canvas2: any;
  ctx2: any;
  dataObject: any;
  lastReport = Date.now();
  intervalRT: any;
  deviceConnected = false;
  loading = false;
  splData: any;
  rangeOverall: any;
  splMode:number;
  splOperativeMode: number;
  splElements: any = [];
  splDataObject: any = {
    relOverload: 0,
    limitPower: 0,
    totalPower: 0,
    valueD: [0, 0],
    gauge: [
      {
        id: 'donutIns0',
        limitPowerByPhase: 0,
        totalPowerByPhase: 0,
        relOverload: 0,
        phase: 'R'
      },
      {
        id: 'donutIns1',
        limitPowerByPhase: 0,
        totalPowerByPhase: 0,
        relOverload: 0,
        phase: 'S'
      },
      {
        id: 'donutIns2',
        limitPowerByPhase: 0,
        totalPowerByPhase: 0,
        relOverload: 0,
        phase: 'T'
      },
    ],
  };
  splDataObject2: any = {
    relChgLineOverload: 0,
    limitPower: 0,
    splEvsePower: 0,
    valueD: [0, 0],
    gauge: [
      {
        id: 'donutChg0',
        splLimitPowerByPhase: 0,
        splEvsePowerByPhase: 0,
        relChgLineOverload: 0,
        phase: 'R'
      },
      {
        id: 'donutChg1',
        splLimitPowerByPhase: 0,
        splEvsePowerByPhase: 0,
        relChgLineOverload: 0,
        phase: 'S'
      },
      {
        id: 'donutChg2',
        splLimitPowerByPhase: 0,
        splEvsePowerByPhase: 0,
        relChgLineOverload: 0,
        phase: 'T'
      },
    ],
  };
  splLimitPower: number;
  splLimitPowerByPhase: number;
  toolTipPbp: any;

  splDevices: any = [];
  listDevicesGroup : any = [];

  constructor(
    private _aRoute: ActivatedRoute,
    public _router: Router,
    private _ws: WebsocketService,
    private _device: DeviceService,
    private _modal: ModalService,
    private _translate: TranslateService
  ) {}

  async ngOnInit(): Promise<void> {
    if(this._device.getSelectedGroupDevices()){
      await this._device.getSelectedGroupDevices().forEach((device: any) => {
        this.listDevicesGroup.push({
          name: device.name,
          serial: device.serial,
          numPhases: device.sys.stat.hwv_pot.includes("3PH") ? (device.sys.cfg.phase!=1 ? 3 : 1) : 1
        });
      });
      localStorage.setItem('listDevicesGroup', JSON.stringify(this.listDevicesGroup));
    }else{
      localStorage.getItem('listDevicesGroup') ? this.listDevicesGroup = JSON.parse(localStorage.getItem('listDevicesGroup') || '') : [];
    }
    this.initComponents();
  }

  initComponents() {
    this.loading = true;
    this.toolTipPbp = this._translate.instant('powerByPhase'),

    this.userRole = sessionStorage.getItem('role') || '';
    this.serial = this._aRoute.snapshot.params.serial;
    /*this._router.events.subscribe((val) => {
      if (
        val instanceof NavigationEnd &&
        this.serial != this._aRoute.snapshot.params.serial &&
        this._router.url.includes('spl')
      ) {
        this.completeRT();
        this.infoModulator = new infoModulator();
        this.deviceConnected = false;
        this.loadData();
        this.connectWS();
      }
    });*/
    this._aRoute.parent?.params.subscribe((params: Params) => {
      this.serial = params['serial'];
    });
    this._device.getDeviceInfo(this.serial).subscribe((data) => {
      this.device = data;
      this._device.setActiveDeviceInfo(data);
      this._device.isOnline(this.serial).subscribe(data => {
        this._modal.showSuccess(this._translate.instant("deviceConnectedToServer"), '');
      }, err => {
        this._modal.showWarn(this._translate.instant("deviceDisconnectedFromServer"), this._translate.instant("connectionCouldNotBeStablished"));
        console.log(err);
      });
    });
    this._device.getModuleInfo(this.serial, "spl").subscribe((data) => {
      console.log(data);
      if(data.cfg){
        this.splMode = data.cfg.splMode
        this.splOperativeMode = data.cfg.splFactory;
        this.splLimitPower = data.cfg.splLimitPower
        this.splLimitPowerByPhase = JSON.parse(data.cfg.splLimitPowerByPhase)
      }
      if (data.stat) {
        let info = JSON.parse(data.stat.splElements);
        info.forEach((x) => {
          this.splElements.push({
            serial: this.getSerial(x.mac),
            pbp: x.power,
            chargeEnergy: x.chargeEnergy,
            connectorId: x.connectorId + 1,
            current: x.current,
            disconnected: x.disconnected,
            flags: x.flags,
            index: x.index,
            isMaster: x.isMaster,
            mac: x.mac,
            phase: x.phase,
            phaseCount: x.phaseCount,
            power: x.phase,
            pwm: this.calcPWM(x.pwm),
            totalEnergy: x.totalEnergy,
          });
        });

        const deviceMap = new Map();

        info.forEach((x) => {
            const serial = this.getSerial(x.mac);

            // Crear un objeto con los valores del conector
            const connector = {
                pbp: x.power,
                chargeEnergy: x.chargeEnergy,
                connectorId: x.connectorId + 1,
                current: x.current,
                flags: x.flags,
                phase: x.phase,
                phaseCount: x.phaseCount,
                power: x.phase,
                pwm: this.calcPWM(x.pwm),
                totalEnergy: x.totalEnergy,
            };

            // Si el serial ya existe en el mapa, agregar el conector al array
            if (deviceMap.has(serial)) {
                deviceMap.get(serial).connectors.push(connector);
                deviceMap.get(serial).disconnected = x.disconnected;
                deviceMap.get(serial).mac = x.mac;
                deviceMap.get(serial).index = x.index;
                deviceMap.get(serial).isMaster = x.isMaster;
            } else {
              var deviceInfo = this.listDevicesGroup.find((device) => this.compareSerialMacCompose(device.serial,serial));
              deviceMap.set(serial, {
                  serial: serial,
                  name: deviceInfo ? deviceInfo.name : null,
                  numPhases: deviceInfo?.numPhases ?? this.listDevicesGroup.find(d => d.serial === serial)?.numPhases ?? 3,
                  completeSerial: deviceInfo ? deviceInfo.serial : null,
                  connectors: [connector],
                  disconnected: x.disconnected,
                  mac: x.mac,
                  index: x.index,
                  isMaster: x.isMaster,
                  phase: x.phase
              });
            }
        });

        this.splDevices = Array.from(deviceMap.values()).sort((a, b) => {
          if (a.isMaster && !b.isMaster) return -1;
          if (!a.isMaster && b.isMaster) return 1;

          if (a.name === null && b.name !== null) return 1;
          if (a.name !== null && b.name === null) return -1;
          if (a.name !== null && b.name !== null) {
            const nameComparison = a.name.localeCompare(b.name);
            if (nameComparison !== 0) return nameComparison;
          }

          return a.serial.localeCompare(b.serial);
        });
        console.log(this.splDevices); // Para verificar el resultado
      }
      console.log(this.splElements);
    });

    var time = this._device.isFirstLoad ? 1000 : 500;
    this.infoModulator = new infoModulator();

    setTimeout(() => {
      this.loadData();
    }, time);
    this.connectWS();
  }

  connectWS() {
    this._ws.connect(this.serial).subscribe({
      next: (data) => {
        this.lastReport = Date.now();
        if (data) {
          switch (data.module) {
            case 'modulator':
              if (!data.element && data.data) {
                this.infoModulator = data.data;
                if (this.charts.length > 0) {
                  this.updatePies(this.infoModulator.stat.status);
                } else {
                  this.loadData();
                }
                break;
              } else {
                break;
              }

            case 'spl':
              this.infoSpl = data.data.stat;
              this.updateTable(this.infoSpl);
              break;
          }
        }
      },
      error: (err) => {
        console.log(err);
      },
        complete: () => console.log('complete')
    });
  }
  startRT(context: any) {
    context._device
      .setRT(this.serial, { period: 1, timeout: 120, status: true })
      .subscribe({
        next: (data: any) => {
          if (data) {
            if (!this.deviceConnected) {
              // this._modal.showSuccess(
              //   this._translate.instant('deviceConnectedToServer'),
              //   ''
              // );
              this.deviceConnected = true;
            }
          }
        },
        error: (err: any) => {
          // if (this.deviceConnected || this.deviceConnected == undefined)
            // this._modal.showWarn(
            //   this._translate.instant('deviceDisconnectedFromServer'),
            //   this._translate.instant('connectionCouldNotBeStablished')
            // );
        }
      });
  }
  completeRT() {
    this._device
      .setRT(this.device, { period: 1, timeout: 120, status: false })
      .subscribe((data) => {
        console.log(data);
      });

    clearInterval(this.intervalRT);
    this._ws.close();
  }
  loadData() {
    this.startRT(this);
    let context = this;
    this.intervalRT = setInterval(() => {
      this.startRT(context);
    }, 120000);

    this._device.getModuleInfo(this.serial, 'modulator').subscribe({
      next: (data) => {
        if (data) {
          if (this.infoModulator) {
            this.loading = false;
            setTimeout(() => {
              try {
                this.loadGraphPie();
              } catch (error) {
                console.error(error);
              }
            }, 300);
          }
        }
      },
      error: (err) => {
        console.error('Error loading modulator data:', err);
      }
    });
  }
  loadGraphPie() {
    for (let index = 0; index < 3; index++) {
      //create installation line donuts
      let labelId = 'donutIns' + index;
      this.canvas = document.getElementById(labelId);
      let ctx = this.canvas.getContext('2d');
      this.charts.push(this.createDoughnutChart(ctx, labelId));
      //create charger line donuts
      let labelId2 = 'donutChg' + index;
      this.canvas2 = document.getElementById(labelId2);
      let ctx2 = this.canvas2.getContext('2d');
      this.charts2.push(this.createDoughnutChart(ctx2, labelId2));
    }
  }
  updatePies(status) {
    //installation line
    let totalPowerByPhase = this.infoModulator.stat.totalPowerByPhase != undefined ? this.extract(this.infoModulator.stat.totalPowerByPhase) : [0, 0, 0];
    let limitPowerByPhase = this.infoModulator.stat.limitPowerByPhase != undefined ? this.extract(this.infoModulator.stat.limitPowerByPhase) : [0, 0, 0];
    let relOverload = this.formatRatio(this.infoModulator.stat.totalPower, this.infoModulator.stat.limitPower);
    //charger line
    let splEvsePower = this.safeNumber(this.infoModulator.stat.splEvsePower);
    const splLimitPower = this.safeNumber(this.splLimitPower);
    let relChgLineOverload = this.safeRatio(splEvsePower, splLimitPower);
    let splEvsePowerByPhase = this.infoModulator.stat.splEvsePowerByPhase != undefined
      ? this.extract(this.infoModulator.stat.splEvsePowerByPhase)
      : [0, 0, 0];
    const splLimitPowerByPhase = Array.isArray(this.splLimitPowerByPhase)
      ? this.splLimitPowerByPhase.map((value) => this.safeNumber(value))
      : [0, 0, 0];
    let donutsChgLineData = this.calcArr(splEvsePowerByPhase, splLimitPowerByPhase);
    //installation line
    this.splDataObject.status = this.infoModulator.stat.status;
    this.splDataObject.totalPowerByPhase = totalPowerByPhase;
    this.splDataObject.relOverload = relOverload;
    this.splDataObject.totalPower = this.formatKw(this.getInstallationPowerWatts());
    this.splDataObject.limitPower = this.formatKw(this.infoModulator.stat.limitPower);
    //charger line
    this.splDataObject2.status = this.infoModulator.stat.status;
    this.splDataObject2.relChgLineOverload = relChgLineOverload.toFixed(2);
    this.splDataObject2.splEvsePower = splEvsePower > 0 ? this.formatKw(splEvsePower) : 0;
    this.splDataObject2.splLimitPower = this.formatKw(splLimitPower);

    var color = status == 0 ? '#0d9488' : status == 1 ? '#cc0000' : '#f1c232';
    var colorLine = status == 0 ? '#5891c3' : status == 1 ? '#cc0000' : '#f1c232';

    for (let index = 0; index < 3; index++) {
      if(totalPowerByPhase[index] > limitPowerByPhase[index])
        color = '#cc0000';
      else
        color = '#0d9488';
      //installation line
      this.splDataObject.gauge[index].limitPowerByPhase = limitPowerByPhase[index];
      this.splDataObject.gauge[index].totalPowerByPhase = totalPowerByPhase[index];
      this.splDataObject.gauge[index].relOverload = this.formatRatio(totalPowerByPhase[index], limitPowerByPhase[index]);

      // Calcular el porcentaje correctamente
      let percentage = 0;
      if (limitPowerByPhase[index] > 0) {
        percentage = Math.min(Math.abs(totalPowerByPhase[index]) / limitPowerByPhase[index], 1);
      }

      if(totalPowerByPhase[index] < 0){
        // Para valores negativos (vertido solar)
        this.charts[index].data.datasets[0].backgroundColor = ['#f1c232', '#e8e8e8'];
        this.charts[index].data.datasets[0].data = [percentage, 1 - percentage];
      }
      else{
        // Para valores positivos (consumo)
        this.charts[index].data.datasets[0].backgroundColor = [color, '#e8e8e8'];
        this.charts[index].data.datasets[0].data = [percentage, 1 - percentage];
      }

      if(splEvsePowerByPhase[index] > splLimitPowerByPhase[index])
        colorLine = '#cc0000';
      else
        colorLine = '#5891c3';
      this.charts[index].update();

      //charger line
      this.splDataObject2.gauge[index].splLimitPowerByPhase = splLimitPowerByPhase[index];
      this.splDataObject2.gauge[index].splEvsePowerByPhase = splEvsePowerByPhase[index];
      this.splDataObject2.gauge[index].relChgLineOverload = donutsChgLineData[index].toFixed(2)

      // Calcular el porcentaje para charger line
      let chargerPercentage = 0;
      if (splLimitPowerByPhase[index] > 0) {
        chargerPercentage = Math.min(splEvsePowerByPhase[index] / splLimitPowerByPhase[index], 1);
      }

      this.charts2[index].data.datasets[0].backgroundColor = [colorLine, '#e8e8e8'];
      this.charts2[index].data.datasets[0].data = [chargerPercentage, 1 - chargerPercentage];
      this.charts2[index].update();
    }
  }
  updateTable(info) {

    /*let newValue = info.splElements;

    for (let i = 0; i < this.splElements.length; i++) {
      this.splElements[i].serial =  newValue[i].mac ? this.getSerial(newValue[i].mac || 0) : '';
      this.splElements[i].pbp = newValue[i].power;
      this.splElements[i].chargeEnergy =  newValue[i].chargeEnergy;
      this.splElements[i].connectorId =  newValue[i].connectorId + 1;
      this.splElements[i].current =  newValue[i].current;
      this.splElements[i].disconnected =  newValue[i].disconnected;
      this.splElements[i].flags =  newValue[i].flags;
      this.splElements[i].index =  newValue[i].index;
      this.splElements[i].isMaster =  newValue[i].isMaster;
      this.splElements[i].mac =  newValue[i].mac;
      this.splElements[i].phase =  newValue[i].phase;
      this.splElements[i].phaseCount =  newValue[i].phaseCount;
      this.splElements[i].power =  newValue[i].phase;
      this.splElements[i].pwm =  this.calcPWM(newValue[i].pwm);
      this.splElements[i].totalEnergy =  newValue[i].totalEnerg;
    }
    return this.splElements*/






    let newValue = info.splElements;
    console.log(newValue);

    // Crear un mapa para agrupar por serial
    const deviceMap = new Map();

    for (let i = 0; i < newValue.length; i++) {

      const mac = newValue[i].mac;
      if (!mac) continue;

      const serial = this.getSerial(mac);
      if (!serial) continue;
        // const serial = newValue[i].mac ? this.getSerial(newValue[i].mac || 0) : '';

        // Crear un objeto con los valores del conector
        const connector = {
            pbp: newValue[i].power,
            chargeEnergy: newValue[i].chargeEnergy,
            connectorId: newValue[i].connectorId + 1,
            current: newValue[i].current,
            flags: newValue[i].flags,
            phase: newValue[i].phase,
            phaseCount: newValue[i].phaseCount,
            power: newValue[i].phase,
            pwm: this.calcPWM(newValue[i].pwm),
            totalEnergy: newValue[i].totalEnerg,
        };

        // Si el serial ya existe en el mapa, agregar el conector al array
      if (deviceMap.has(serial)) {
        const existing = deviceMap.get(serial);
        existing.connectors.push(connector);
        existing.disconnected = newValue[i].disconnected;
        existing.mac = mac;
        existing.index = newValue[i].index;
        existing.isMaster = newValue[i].isMaster;
      } else {
        const deviceInfo = this.listDevicesGroup.find((d) => this.compareSerialMacCompose(d.serial, serial));
        deviceMap.set(serial, {
          serial,
          name: deviceInfo?.name ?? null,
          completeSerial: deviceInfo?.serial ?? null,
          numPhases: deviceInfo?.numPhases ?? this.listDevicesGroup.find(d => d.serial === serial)?.numPhases ?? 3,
          connectors: [connector],
          disconnected: newValue[i].disconnected,
          mac,
          index: newValue[i].index,
          isMaster: newValue[i].isMaster,
          phase: newValue[i].phase
        });
      }
    }

    this.splDevices = Array.from(deviceMap.values()).sort((a, b) => {
      if (a.isMaster && !b.isMaster) return -1;
      if (!a.isMaster && b.isMaster) return 1;

      if (a.name === null && b.name !== null) return 1;
      if (a.name !== null && b.name === null) return -1;
      if (a.name !== null && b.name !== null) {
        const nameComparison = a.name.localeCompare(b.name);
        if (nameComparison !== 0) return nameComparison;
      }

      return a.serial.localeCompare(b.serial);
    });

    console.log(this.splDevices);
  }

  calculateRange(limitP, totalC) {
    if (limitP != 0 || totalC != 0) {
      let percent = (totalC / limitP) * 100;
      if (percent < 0 || percent == -0 || isNaN(percent)) {
        return 0;
      } else {
        return percent;
      }
    }
    return 0;
  }
  goToLink(serial: string) {
    if (serial[4] === '4') {
      window.open(
        `https://dev.orbis.com.es/chronograf/sources/1/dashboards/18?tempVars%5Bserial%5D=${serial}`,
        '_blank'
      );
    } else {
      window.open(
        `https://dev.orbis.com.es/chronograf/sources/1/dashboards/19?tempVars%5Bserial%5D=${serial}`,
        '_blank'
      );
    }
  }
  extract(string) {
    let arrayifyData: number[] = [];
    if (string != undefined) {
      string.forEach((x) => {
        const value = parseFloat(x);
        arrayifyData.push(Number.isFinite(value) ? value : 0);
      });
      return arrayifyData;
    }
    return arrayifyData;
  }
  getSerial(string) {
    let mac = string.split(':').join('').toUpperCase();
    return 'EVVC_' + mac;
  }
  getSlaveCons(array) {
    if (array.length === 0) {
      return 0;
    }
    const sum = array.reduce((total, num) => total + num, 0).toFixed(2);
    return sum / array.length;
  }
  calcArr(arr1: any[], arr2: any): number[] {
    const result: number[] = [];
    for (let i = 0; i < arr1.length; i++) {
      result.push(this.safeRatio(this.safeNumber(arr1[i]), this.safeNumber(arr2[i])));
    }
    return result;
  }

  // Potencia mostrada en la tarjeta de instalación (W)
  private getInstallationPowerWatts(): number {
    const totalPower = this.safeNumber(this.infoModulator?.stat?.totalPower);
    const instPower = this.safeNumber(this.infoModulator?.stat?.instPower);

    if (totalPower !== 0) {
      return totalPower;
    }

    return instPower;
  }

  formatPhaseKw(watts: unknown): string {
    return this.formatKw(watts);
  }

  formatOverloadPercent(value: unknown): string {
    const ratio = this.safeNumber(value);
    return Number.isFinite(ratio) ? (ratio * 100).toFixed(0) : '0';
  }

  private safeNumber(value: unknown, fallback = 0): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  private safeRatio(numerator: unknown, denominator: unknown): number {
    const num = this.safeNumber(numerator);
    const den = this.safeNumber(denominator);
    if (den === 0) {
      return 0;
    }
    return num / den;
  }

  private formatKw(watts: unknown): string {
    return (this.safeNumber(watts) / 1000).toFixed(2);
  }

  private formatRatio(numerator: unknown, denominator: unknown): string {
    return this.safeRatio(numerator, denominator).toFixed(2);
  }
  calcRelChgLineOverload(relOverload:any, relOverloadByPhase: any[]){

    relOverloadByPhase.push(relOverload);
    relOverloadByPhase.sort((a, b) => b - a);
    return relOverloadByPhase[0];
  }
  createDoughnutChart(context, labelId) {
    return new Chart(context, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [0, 1], // Empieza vacío: 0% usado, 100% disponible
            backgroundColor: ['#39b690', '#e8e8e8'], // Color usado, color disponible
            hoverBorderWidth: 0,
            borderWidth: 0
          },
        ],
      },
      options: {
        cutout: '80%', // Controla el grosor del donut (más alto = más delgado)
        plugins: {
          tooltip: {
            enabled: false
          }
        },
        interaction: {
          intersect: false
        },
        animation: {
          duration: 0 // elimina animación
        }
      },
    });
  }
  calcPWM(numbers: number[]): number {
    const nonZeroNumbers = numbers.filter(num => num !== 0);
    if (nonZeroNumbers.length === 0) {
        return 0;
    }
    const minNonZero = Math.min(...nonZeroNumbers);
    return minNonZero / 1000
  }

  formatNumber(value: number): string {
    if (!Number.isFinite(value)) {
      return '0';
    }
    if (value % 1 === 0) {
      // Si el número es entero, devolverlo sin decimales
      return value.toString();
    }
    // Si el número es decimal, formatearlo con 2 decimales y usar punto como separador
    return value.toFixed(2);
  }

  compareSerialMacCompose(str1, str2) {
    if (str1.length !== str2.length) return false;
    for (let i = 0; i < str1.length; i++) {
      if (i === 4) continue;
      if (str1[i] !== str2[i]) return false;
    }
    return true;
  }

  goToDevice(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}/diagnosis`)
  }
}




